export const computePressureFromDepthPsia = (
  datumPointFt: number,
  depthFt: number,
  liquidDensityLbmft3: number
) => {
  return ((datumPointFt - depthFt) * liquidDensityLbmft3) / 144.144;
};

export const computeFluidLevelFeet = (
  datumPointFt: number,
  bottomHolePressurePsia: number,
  liquidDensityLbmFt3: number
) => {
  const pressureHeadFt =
    (bottomHolePressurePsia / liquidDensityLbmFt3) * 144.144;
  return datumPointFt - pressureHeadFt;
};
